import ConfirmAccount from "components/ConfirmAccount/ConfirmAccount";

const ConfirmAccountPage = () => {
  return (
    <div className="w-full">
      <div>
        <ConfirmAccount />
      </div>
    </div>
  );
};

export default ConfirmAccountPage;
